import React, {useRef, useState, useEffect, useMemo, useCallback} from "react";
import axios from "axios";
import "./AddDocumentToCase.css";
import ConfirmationModal from "../../../components/ConfirmationModal/ConfirmationModal";
import CaseFilesInternal from "../../../enums/CaseFilesInternal";
import {IoIosCloseCircle} from "react-icons/io";
import CaseFilesStatus from "../../../enums/CaseFilesStatus";
import CaseFileDeclined from "../../../enums/CaseFileDeclined";
import {useLocation} from "react-router-dom";
import {Button, TextField, Tooltip} from "@mui/material";
import {FormControl, InputLabel, MenuItem, Select} from "@mui/material";
import JoditEditor from "jodit-react";
import {jwtDecode} from "jwt-decode";
import CaseNotificationEnum from "../../../enums/CaseNotiFicationEnum";
import {IoEye, IoTrash} from "react-icons/io5";
import htmlEnums from "../../../enums/htmlEnums";
import TemplateEnum from "../../../enums/templateEnum";
import {debounce} from "lodash";
import {formatHtmlForEditor} from "../../../components/globalFunctions/globalFunctions";
import dummyFiles from "./base64";
import {AiOutlineCheckCircle} from "react-icons/ai";

const DenyCaseDocument = ({
                              onFileAdded,
                              selectedDocuments,
                              isDisabled,
                              hasDisabledTextField,
                              removeCheckboxes,
                              docType,
                              buttonTitle,
                              currentUserId,
                              userId,
                              objectOwner,
                              caseGeography,
                              barcode,
                              users,
                              caseInfo,
                              permitTypeTitle,
                              ownerIdentificationTemplateString,
                              exploitationIdentificationTemplateString,
                              isAddressRejected,
                              isCadastralCodeRejected,
                              declinedDetails,
                              address,
                              cadastralCodeArray,
                              userAddress
                          }) => {
    const [title, setTitle] = useState("დახარვეზების აქტი");
    const [prolongationDays, setProlongationDays] = useState(null)
    const [documentType, setDocumentType] = useState("");
    const [extraDescription, setExtraDescription] = useState("");
    const [showPopup, setShowPopup] = useState(false);
    const [loading, setLoading] = useState(false);
    const [editorContent, setEditorContent] = useState(docType.textHTML ? docType.textHTML : '');
    const [closing, setClosing] = useState(false);
    const [isButtonDisabled, setIsButtonDisabled] = useState(true);
    const [isConfirmModalOpen, setIsConfirmModalOpen] = useState(false);
    const [previewContent, setPreviewContent] = useState('');
    const location = useLocation();
    const caseId = new URLSearchParams(location.search).get('id');
    const [file, setFile] = useState(null);
    const [fileTitle, setFileTitle] = useState("დახარვეზების აქტის დანართი");
    const fileInputRef = useRef(null);
    const caseIdForFile = new URLSearchParams(location.search).get('id');
    const [alert, setAlert] = useState({show: false, message: '', type: ''});
    const [disableText, setDisableText] = useState("");
    const [fontFamily, setFontFamily] = useState('Sylfaen');
    const [documentId, setDocumentId] = useState('');
    const [closeModalOn, setCloseModalOn] = useState(false);
    const [roleId, setRoleId] = useState('');
    const [mainUserId, setMainUserId] = useState("");
    const [headerContent, setHeaderContent] = useState('');
    const [debouncedContent, setDebouncedContent] = useState(editorContent);
    const [htmlLoaded, setHtmlLoaded] = useState(false);
    const [declinedCaseGeography, setDeclinedCaseGeography] = useState([]);

    useEffect(() => {
        const declinedCaseGeography = Object.entries(caseGeography)
            .filter(([_, value]) => value?.rejected === 1)
            .map(([key, value]) => ({key, ...value}));
        setDeclinedCaseGeography(declinedCaseGeography)
    }, [caseGeography]);


    useEffect(() => {
        if (htmlEnums && Object.keys(htmlEnums).length > 0) {
            setHtmlLoaded(true);
        }
    }, []);

    const uploadFileToGetDocumentNumber = async () => {

        const file = {
            caseID: parseInt(caseId),
            name: "test",
            ext: "pdf",
            file: dummyFiles.dummy,
            mainInfo: "",
            additionalInfo: "",
            shared: true,
            blank: false,
            documentType: 0,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.Sent,
            decline: CaseFileDeclined.No,
            declinedInternalStatus: 0,
        }


        const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, file);

        const caseFilesResponse = await axios.get(`${process.env.REACT_APP_API_BASE_URL}/GetAllCaseFileByCaseID?CaseId=${caseId}`);

        const caseFiles = caseFilesResponse.data.data.resultItems

        const caseFile = caseFiles.find(file => file.id === parseInt(response.data.resultId))

        await axios.put(`${process.env.REACT_APP_API_BASE_URL}/DeleteCaseFile`, {caseFileId: response.data.resultId})

        return caseFile.documentNumber;

    }


    const debouncedUpdatePreview = useCallback(debounce(newContent => {
        setDebouncedContent(newContent);
    }, 50), []);


    useEffect(() => {
        debouncedUpdatePreview(editorContent);
    }, [editorContent, debouncedUpdatePreview]);


    const PdfPreviewContent = useMemo(() => {
        return (
            <div className="pdf-preview-container" style={{fontFamily}}>
                <Button
                    variant="contained"
                    color="primary"
                    style={{marginBottom: 28}}
                    startIcon={<AiOutlineCheckCircle/>}
                >
                    ცვლილების ნახვა
                </Button>
                <div id="pdf-page" className="pdf-page" style={{fontFamily}}>
                    <div dangerouslySetInnerHTML={{__html: headerContent}}/>
                    <div dangerouslySetInnerHTML={{__html: previewContent}}/>
                    <div style={{marginTop: 10}}
                         dangerouslySetInnerHTML={{__html: debouncedContent}}/>
                </div>

            </div>
        );
    }, [fontFamily, previewContent, debouncedContent, headerContent]);

    useEffect(() => {
        if (showPopup) {
            document.body.style.overflow = 'hidden';
        } else {
            document.body.style.overflow = 'auto';
        }
        return () => {
            document.body.style.overflow = 'auto';
        };
    }, [showPopup]);

    useEffect(() => {
        const token = localStorage.getItem("jwtTokenMain");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setMainUserId(decoded.UserId);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    useEffect(() => {
        const token = localStorage.getItem("jwtToken");
        if (token) {
            try {
                const decoded = jwtDecode(token);
                setRoleId(decoded.role);
            } catch (error) {
                setRoleId("");
            }
        }
    }, []);

    const sendNotification = async (fileId) => {
        const documentIds = Object.values(selectedDocuments).map(doc => `${doc.id}`);
        const headOfAgency = users.find(user => user.roleName === "HeadOfAgency");
        const deputyHeadOfAgency = users.find(user => user.roleName === "DeputyHeadOfAgency");

        const caseNotification = {
            nextStepUserId: roleId === "HEADOFAGENCY" ? deputyHeadOfAgency.id : headOfAgency.id,
            caseId: caseId ? parseInt(caseId, 10) : 0,
            documentId: fileId,
            action: CaseNotificationEnum.createdFile.id,
            caseStatus: 8,
            viewed: true,
            caseFileIds: documentIds,
        };

        await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseNotification`, caseNotification);
    };

    const georgianTranslations = {
        "Type something": " ",
        "Bold": "ტექსტის გამუქება",
        "Italic": "დახრილი ტექსტის შექმნა",
        "Underline": "ტექსტის ხაზგასმა",
        "Insert Image": "სურათის ჩასმა",
        "Clear Formatting": "ფორმატირების წაშლა",
        "Insert Format Block": "ფორმატირების ბლოკის ჩასმა",
        "Strike through": "გადახაზული",
        "Insert Unordered List": "ბურთულებიანი სიის შექმნა",
        "Insert Ordered List": "დანომრილი სიის შექმნა",
        "Font family": "შრიფტის არჩევა",
        "Font size": "შრიფტის ზომა",
        "Line height": "ხაზის დაშორება",
        "Insert Horizontal Line": "ხაზის დაშორება",
        "Increase Indent": "დაშორების გაზრდა",
        "Decrease Indent": "დაშორების შემცირება",
        "Undo": "უკუსვლა",
        "Redo": "საწყისი",
        "Align": "სწორება",
        "Insert Special Character": "სპეც. სიმბოლო",
        "Fill color or set the text color": "ფერის შეცვლა",
        "Background": "ფონი",
        "Text": "ტექსტი",
        "Insert format block": "ფორმატირება",
        "Print": "დაბეჭვდა",
        "Show all": "მეტის ნახვა",
        "Insert link": "ბმლის ჩასმა",
        "URL": "ბმული",
        "Open in new tab": "ახალ გვერდზე გახსნა",
        "Insert": "ჩასმა"
    };

    const mapFontFamilyToStyles = (fontName) => {
        const fontStyles = {
            'Arial': {
                fontFamily: 'arial_geo',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            },
            'Sylfaen': {
                fontFamily: 'sylfaen',
                bold: 'arial_geo-bold',
                italics: 'arial_geo-italic',
                bolditalics: 'arial_geo-bold-italic'
            }
        };
        return fontStyles[fontName] || fontStyles['Arial'];
    };


    const editorConfig = useMemo(() => ({
        readonly: false,
        toolbarButtonSize: "middle",
        askBeforePasteHTML: false,
        askBeforePasteFromWord: false,
        language: 'ka',
        i18n: {
            ka: georgianTranslations,
        },
        style: {
            fontFamily: mapFontFamilyToStyles(fontFamily).fontFamily,
        },
        height: 800,
        disablePlugins: [
            'spellcheck',
            'speech-recognize',
            'open-in-fullsize',
            'add-new-line',
            'Insert-file',
            'ai-assistant',
            'file',
            'image',
            'video',
            'fullsize',
            'about',
            'preview',
            'symbols',
            'symbol',
        ],
        controls: {
            font: {
                list: {
                    'Arial': 'Arial',
                    'Sylfaen': 'Sylfaen'
                }
            }
        },
        buttons: ["bold", "italic", "underline", "|", "subscript", "superscript"]

    }), []);


    useEffect(() => {
        const styleSheet = document.createElement('style');
        styleSheet.type = 'text/css';
        styleSheet.innerText = `
        .jodit-container * {
            font-family: ${mapFontFamilyToStyles(fontFamily).fontFamily} !important;
        }
    `;
        document.head.appendChild(styleSheet);

        return () => {
            document.head.removeChild(styleSheet);
        };
    }, [fontFamily]);

    const preprocessHtmlForPdf = (html, docNumber) => {
        const container = document.createElement('div');
        container.innerHTML = html.replace('{დოკუმენტის ნომერი}', "№ " + docNumber);
        const elementsWithStyle = container.querySelectorAll('[style]');
        elementsWithStyle.forEach(element => {
            const style = element.style;
            if (style.fontSize && isNaN(parseFloat(style.fontSize))) {
                style.fontSize = '16px';
            }
            if (style.textDecoration === 'none') {
                style.textDecoration = '';
            }
        });
        const tables = container.querySelectorAll('table');
        tables.forEach(table => {
            table.style.width = '100%';
            const rows = table.querySelectorAll('tr');
            rows.forEach(tr => {
                tr.querySelectorAll('td, th').forEach(td => {
                    td.style.padding = '8px';
                });
            });
        });
        return container.innerHTML;
    };


    useEffect(() => {
        const handleKeyDown = (event) => {
            if (event.key === 'Escape' && showPopup) {
                setCloseModalOn(true)
            }
        };

        window.addEventListener('keydown', handleKeyDown);

        return () => {
            window.removeEventListener('keydown', handleKeyDown);
        };
    }, [closing, showPopup]);

    useEffect(() => {
        const fetchAndSetBarcode = async () => {
            if (docType && htmlLoaded) {
                setDocumentType(docType.documentTypeStatus);
                setTitle(docType.name);
                let blankHtmlContent = docType.blank;
                const barcodeImageBase64 = barcode;
                if (barcodeImageBase64 && docType.templateType !== TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContent(barcodeImageBase64, blankHtmlContent);
                } else if (barcodeImageBase64 && docType.templateType === TemplateEnum.insideLetter) {
                    blankHtmlContent = insertBarcodeIntoContentForInsideLetter(barcodeImageBase64, blankHtmlContent)
                }
                setPreviewContent(blankHtmlContent);
                if (docType.templateType !== null) {
                    if (docType.templateType === TemplateEnum.order) {
                        setHeaderContent(htmlEnums.order)
                    } else if (docType.templateType === TemplateEnum.letter) {
                        setHeaderContent(htmlEnums.letter)
                    }

                }

                setPreviewContent(blankHtmlContent);
            }
        };

        void fetchAndSetBarcode();
    }, [docType, htmlLoaded]);


    const handleFontChange = (e) => {
        setFontFamily(e.target.value);
    };


    const preprocessEditorContent = (htmlContent) => {
        const parser = new DOMParser();
        const doc = parser.parseFromString(htmlContent, 'text/html');

        doc.querySelectorAll('p, br').forEach(el => {
            if (el.style.marginTop === '70px') {
                el.style.marginTop = '0px';
            }
        });

        return doc.body.innerHTML;
    };


    useEffect(() => {
        const processedContent = preprocessEditorContent(editorContent);
        setEditorContent(processedContent);
    }, [editorContent]);

    const replacePlaceholders = (htmlContent) => {
        let createDate
        const date = new Date(caseInfo.createDate);
        if (isNaN(date)) {
            createDate = 'caseDate';
        } else {
            createDate = `${date.getDate().toString().padStart(2, '0')}/${(date.getMonth() + 1).toString().padStart(2, '0')}/${date.getFullYear()}`
        }

        const signeeUser = users.find(user => user.roleName === "HeadOfAgency")
        const userName = users.find(user => user.id === userId)
        const mainUserName = users.find(user => user.id === mainUserId)
        if (userId === mainUserId) {
            return htmlContent

                .replace(/\$requesterName\$/g, userName.firstName + ' ' + userName.lastName)
                .replace(/\$receiverName\$/g, objectOwner ? objectOwner : "")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString())
        } else {
            return htmlContent
                .replace(/\$requesterName\$/g, userName.firstName + ' ' + userName.lastName + "(-ის) მოვალეობის შემსრულებელი " + mainUserName.firstName + ' ' + mainUserName.lastName)
                .replace(/\$receiverName\$/g, objectOwner ? objectOwner : "")
                .replace(/\$signee\$/g, signeeUser.firstName + ' ' + signeeUser.lastName)
                .replace(/\$caseDate\$/g, createDate)
                .replace(/\$address\$/g, userAddress)
                .replace(/\$permitType\$/g, permitTypeTitle)
                .replace(/\$objectName\$/g, caseInfo.request)
                .replace(/\$objectOwnerIdentificationNumber\$/g, ownerIdentificationTemplateString)
                .replace(/\$exploitationIdentificationNumber\$/g, exploitationIdentificationTemplateString)
                .replace(/\$caseNumber\$/g, caseInfo.caseNumber.toString())
        }
    };

    useEffect(() => {
        if (docType.textHTML && mainUserId) {
            const updatedContent = replacePlaceholders(docType.textHTML);
            setEditorContent(updatedContent);
        }
    }, [docType.textHTML, mainUserId]);

    useEffect(() => {
        if (isDisabled) {
            setIsButtonDisabled(true)
            setDisableText("დახარვეზების აქტი უკვე არსებობს.")
        } else if (hasDisabledTextField) {
            setIsButtonDisabled(false)
            setDisableText("")

        } else if (isAddressRejected) {
            setIsButtonDisabled(false)
            setDisableText("")
        } else if (isCadastralCodeRejected) {
            setIsButtonDisabled(false)
            setDisableText("")
        } else if (!(Object.keys(selectedDocuments).length === 0)) {
            setIsButtonDisabled(false)
            setDisableText("")

        } else {
            setIsButtonDisabled(true)
            setDisableText("აქტის შექმნისთვის აირჩიეთ დოკუმენტი ან ველი, რომლის დახარვეზებაც გსურთ.")
        }


    }, [hasDisabledTextField, isDisabled, Object.keys(selectedDocuments).length]);

    const insertBarcodeIntoContent = (base64ImageData, htmlContent) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = htmlContent

        const table = document.createElement('table')
        table.style.width = '100%'
        table.style.borderCollapse = 'collapse'
        table.style.border = 'none'

        const headerRow = document.createElement('tr')

        const dateTableCell = document.createElement('td')
        dateTableCell.style.verticalAlign = 'middle'
        dateTableCell.style.border = 'none'
        dateTableCell.style.padding = '0'
        dateTableCell.style.color = 'black'
        dateTableCell.style.fontFamily = 'Sylfaen'
        dateTableCell.style.fontSize = '20px'
        dateTableCell.textContent = '{ხელმოწერის თარიღი}'

        headerRow.appendChild(dateTableCell)

        const barcodeTableCell = document.createElement('td')
        barcodeTableCell.style.verticalAlign = 'middle'
        barcodeTableCell.style.textAlign = 'right'
        barcodeTableCell.style.border = 'none'
        barcodeTableCell.style.padding = '0'

        const barcodeContainer = document.createElement('div')

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '200px'
        barcodeImage.style.height = '50px'

        barcodeContainer.appendChild(barcodeImage)

        const generateRandomNumberString = length => {
            let generatedValue = ''
            for (let index = 0; index < length; index++) {
                generatedValue += Math.floor(Math.random() * 10)
            }
            return generatedValue
        }

        const barcodeText = 'KA' + generateRandomNumberString(15)

        const barcodeTextDiv = document.createElement('div')
        barcodeTextDiv.style.fontSize = '14px'
        barcodeTextDiv.style.color = 'black'
        barcodeTextDiv.style.fontFamily = 'Sylfaen'
        barcodeTextDiv.textContent = barcodeText

        barcodeContainer.appendChild(barcodeTextDiv)
        barcodeTableCell.appendChild(barcodeContainer)

        headerRow.appendChild(barcodeTableCell)
        table.appendChild(headerRow)

        const documentRow = document.createElement('tr')

        const documentNumberCell = document.createElement('td')
        documentNumberCell.style.verticalAlign = 'middle'
        documentNumberCell.style.border = 'none'
        documentNumberCell.style.padding = '0'
        documentNumberCell.style.paddingTop = '50px'

        const documentNumberDiv = document.createElement('div')
        documentNumberDiv.textContent = '{დოკუმენტის ნომერი}'
        documentNumberDiv.style.fontSize = '18px'
        documentNumberDiv.style.color = 'black'
        documentNumberDiv.style.fontFamily = 'Sylfaen'

        documentNumberCell.appendChild(documentNumberDiv)

        const emptyCell = document.createElement('td')
        emptyCell.style.border = 'none'
        emptyCell.style.padding = '0'

        documentRow.appendChild(documentNumberCell)
        documentRow.appendChild(emptyCell)

        table.appendChild(documentRow)

        tempDiv.appendChild(table)
        return tempDiv.innerHTML
    }

    const insertBarcodeIntoContentForInsideLetter = (base64ImageData) => {
        const tempDiv = document.createElement('div')
        tempDiv.innerHTML = '<div></div>'

        const contentContainer = document.createElement('div')
        contentContainer.style.position = 'relative'
        contentContainer.style.width = '100%'
        contentContainer.style.textAlign = 'right'

        tempDiv.appendChild(contentContainer)

        const barcodeImage = document.createElement('img')
        barcodeImage.src = base64ImageData
        barcodeImage.style.width = '150px'
        barcodeImage.style.height = '30px'

        contentContainer.appendChild(barcodeImage)

        const insideLetterDiv = document.createElement('div')
        insideLetterDiv.innerHTML = htmlEnums.insideLetter
        insideLetterDiv.style.marginTop = '10px'
        insideLetterDiv.style.textAlign = 'center'

        contentContainer.appendChild(insideLetterDiv)

        const dateSpan = document.createElement('span')
        dateSpan.textContent = "{ხელმოწერის თარიღი}"
        dateSpan.style.fontSize = '18px'
        dateSpan.style.color = 'black'
        dateSpan.style.marginRight = '15px'
        dateSpan.style.fontFamily = 'Sylfaen'
        dateSpan.style.letterSpacing = '-0.5px'

        contentContainer.appendChild(dateSpan)

        return tempDiv.innerHTML
    }

    const handleFileChange = (event) => {
        const selectedFile = event.target.files[0];
        if (selectedFile) {
            if (selectedFile.type !== 'application/pdf') {
                setAlert({show: true, message: 'შეცდომა: ატვირთეთ მხოლოდ PDF ფაილები.', type: 'error'});
                setFile(null);
            } else {
                setFile(selectedFile);
                setAlert({...alert, show: false});
            }
        }
    };

    const handleFileDelete = () => {
        setFile(null);
        fileInputRef.current.value = '';
    };


    const toBase64 = file => new Promise((resolve, reject) => {
        const reader = new FileReader();
        reader.readAsDataURL(file);
        reader.onload = () => resolve(reader.result.split(',')[1]);
        reader.onerror = error => reject(error);
    });

    const performUpload = async () => {
        if (!file) {
            return;
        }
        const fileBase64 = await toBase64(file);


        const fileData = {
            caseID: parseInt(caseIdForFile),
            name: fileTitle || "დახარვეზების აქტის დანართი",
            ext: file.name.split('.').pop(),
            file: fileBase64,
            mainInfo: "",
            additionalInfo: "",
            sharedTemp: true,
            shared: false,
            blank: false,
            documentType: 1,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.ReadyForVisage,
            decline: CaseFileDeclined.No,
            parentId: documentId,
            declinedInternalStatus: 0,
            activeUserId: userId,
        };

        try {
            await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, fileData);
            onFileAdded();
        } catch (error) {
            console.error(error);
        }
    };


    useEffect(() => {
        const performUploadIfDocumentIdExists = async () => {
            if (documentId) {
                await performUpload();
                onFileAdded();
            }
        };
        void performUploadIfDocumentIdExists();
    }, [documentId]);


    function isEditorContentEmpty(content) {
        return !content.replace(/<[^>]*>/g, '').trim();
    }

    const isSubmitDisabled = !title || isEditorContentEmpty(editorContent) || !documentType || !prolongationDays;

    const handleClosePopup = () => {
        setCloseModalOn(false)
        setClosing(true);
        setTimeout(() => {
            setShowPopup(false);
            setClosing(false);
        }, 100);
    };


    const handleSubmit = (e) => {
        e.preventDefault();
        setIsConfirmModalOpen(true);
    };

    const handlePreview = (file) => {
        if (file) {
            const url = URL.createObjectURL(file);
            window.open(url, '_blank');
        }
    };

    const handleConfirmSubmit = async () => {

        const fileNumber = await uploadFileToGetDocumentNumber();

        setIsConfirmModalOpen(false);
        setLoading(true);
        const forceFontFamily = (htmlContent) => {
            const container = document.createElement('div');
            container.innerHTML = htmlContent;
            Array.from(container.querySelectorAll("*")).forEach(el => {
                el.style.fontFamily = fontFamily;
            });
            return container.innerHTML;
        };

        const updatedPreviewContent = forceFontFamily(previewContent.replace(/background-color:\s*transparent;\s*/g, ''));
        const updatedEditorContent = forceFontFamily(editorContent.replace(/background-color:\s*transparent;\s*/g, ''));

        setPreviewContent(updatedPreviewContent);
        setEditorContent(updatedEditorContent);

        const processedContent = preprocessHtmlForPdf(`<div style="font-family: ${fontFamily}">${headerContent}${updatedPreviewContent}${updatedEditorContent}</div>`, fileNumber);
        const processedHtml = formatHtmlForEditor(processedContent);


        for (const file of Object.values(selectedDocuments)) {
            const requestBody = {
                id: file.id,
                caseID: file.caseID,
                name: file.name,
                mainInfo: file.mainInfo,
                additionalInfo: file.additionalInfo,
                shared: file.shared,
                blank: file.blank,
                documentType: file.documentType,
                internal: file.internal,
                status: file.status,
                decline: CaseFileDeclined.Yes,
                fileTypeId: file.fileTypeId,
                declineByUser: currentUserId,
                documentNumber: file.documentNumber

            };

            try {
                await axios.put(`${process.env.REACT_APP_API_BASE_URL}/EditCaseFile`, requestBody);
            } catch (error) {
                console.error(error);
            }
        }

        const requestBody = {
            caseID: parseInt(caseId),
            name: title,
            ext: 'pdf',
            mainInfo: processedHtml,
            additionalInfo: extraDescription,
            shared: false,
            blank: true,
            sharedTemp: true,
            documentType: documentType,
            internal: CaseFilesInternal.No,
            status: CaseFilesStatus.ReadyForVisage,
            decline: CaseFileDeclined.DeclinationDocument,
            tempProlongationDays: prolongationDays,
            declinedInternalStatus: 0,
            activeUserId: userId,
            caseFileNumber: fileNumber,
            html: processedHtml,
            isHTML: true,
            skipVisage: docType.skipVisage
        };

        try {
            const response = await axios.post(`${process.env.REACT_APP_API_BASE_URL}/AddNewCaseFile`, requestBody);
            setDocumentId(response.data.resultId);
            await sendNotification(response.data.resultId)
            await performUpload();
            onFileAdded();
        } catch (error) {
            console.error(error);
        } finally {
            setLoading(false);
            setShowPopup(false);
        }
        removeCheckboxes();
    };


    const renderSelectedDocumentTitles = () => {
        return Object.values(selectedDocuments).map((file, index) => (
            <div key={index} className="selected-document-title">{file.name}</div>
        ));
    };

    const renderDeclinedDetails = () => {
        return (
            <ul className="declined-details-list">
                {declinedDetails.map((item) => (
                    <div key={item.id} className="selected-document-title">
                        {item.key}: {item.value}
                    </div>
                ))}
                {caseGeography.region.rejected === 1 && caseGeography.region.id !== "" &&
                    (
                        <div className="selected-document-title">რეგიონი: {caseInfo.regionsNames}</div>
                    )
                }
                {caseGeography.city.rejected === 1 && caseGeography.city.id !== "" &&
                    (
                        <div className="selected-document-title">მუნიციპალიტეტი: {caseInfo.citysNames}</div>
                    )
                }

                {caseGeography.council.rejected === 1 && caseGeography.council.id !== "" &&
                    (
                        <div className="selected-document-title">საკრებულო: {caseInfo.councilsNames}</div>
                    )
                }
                {caseGeography.populatedArea.rejected === 1 && caseGeography.populatedArea.id !== "" &&
                    (
                        <div className="selected-document-title">დასახლებული პუნქტი: {caseInfo.populatedAreasNames}</div>
                    )
                }
                {isAddressRejected  && address !== "" &&
                    (
                        <div className="selected-document-title">მისამართი: {address}</div>
                    )
                }
                {isCadastralCodeRejected  && cadastralCodeArray !== "" &&
                    (
                        <div className="selected-document-title">
                            საკადასტრო კოდი: {cadastralCodeArray.split("$").join(", ")}
                        </div>

                    )
                }
            </ul>
        );
    };


    return (
        <div>
            <Tooltip title={disableText}>
                <button
                    className={"document-button-red"}
                    onClick={() => {
                        setShowPopup(true);
                    }}
                    disabled={isButtonDisabled}
                >
                    {loading ? "იტვირთება..." : buttonTitle}
                </button>
            </Tooltip>
            {showPopup && (
                <div className="overlay" onClick={() => setCloseModalOn(true)}></div>
            )}
            {showPopup && (
                <div className={`custom-scrollbar popup-editor ${closing ? 'popup-closing' : ''}`}>
                    {loading ? (
                        <div className="loader"></div>
                    ) : (


                        <div className="editor-and-preview-container">
                            {isConfirmModalOpen && (<div className="overlay-modal"></div>)}
                            <div>
                                <form onSubmit={handleSubmit}>
                                    <input
                                        type="text"
                                        value={title}
                                        onChange={(e) => setTitle(e.target.value)}
                                        placeholder="სათაური"
                                        className={"add-doc-input"}
                                    />
                                    <input
                                        type="text"
                                        value={prolongationDays}
                                        onChange={(e) => {
                                            const value = e.target.value.replace(/\D/g, '');
                                            setProlongationDays(value);
                                        }}
                                        placeholder="დახარვეზების დღეები"
                                        className="add-doc-input"
                                    />

                                    <div className="q-editor-container">

                                        <FormControl fullWidth style={{marginBottom: 8}}>
                                            <InputLabel id="font-family-label">შრიფტი</InputLabel>
                                            <Select
                                                labelId="font-family-label"
                                                value={fontFamily}
                                                label="შრიფტი"
                                                onChange={handleFontChange}
                                                sx={{backgroundColor: 'white', borderRadius: 1}}
                                            >
                                                <MenuItem value="DejaVu">DejaVu Sans</MenuItem>
                                                <MenuItem value="Sylfaen">Sylfaen</MenuItem>

                                            </Select>
                                        </FormControl>

                                        <JoditEditor
                                            key={fontFamily}
                                            value={editorContent}
                                            config={editorConfig}
                                            tabIndex={1}
                                            onBlur={editorContent => setEditorContent(editorContent)}
                                        />

                                    </div>

                                    <textarea
                                        value={extraDescription}
                                        onChange={(e) => setExtraDescription(e.target.value)}
                                        placeholder="დამატებითი აღწერა"
                                        style={{
                                            width: "99.39%",
                                            height: "200px",
                                            resize: "vertical",
                                            margin: "10px 0",
                                        }}
                                    />


                                    <div className="selected-documents-container">
                                        <h4>დახარვეზებული დოკუმენტები:</h4>
                                        {renderSelectedDocumentTitles()}
                                    </div>
                                    <div className="selected-documents-container">
                                        <h4>დახარვეზებული ველები:</h4>
                                        {renderDeclinedDetails()}
                                    </div>
                                    <Tooltip
                                        title={isSubmitDisabled ? "შეავსეთ ყველა ველი" : prolongationDays === "0" ? "მიუთითეთ დახარვეზების დღეები" : prolongationDays > 100 ? "დრეების მაქსიმალური რაოდენობა 100!" : ``}>
                                        <span>
                                            <button
                                                type="submit"
                                                style={{
                                                    backgroundColor: isSubmitDisabled || prolongationDays === "0" || prolongationDays > 100 ? '#ccc' : '#2E76E4',
                                                    color: isSubmitDisabled || prolongationDays === "0" || prolongationDays > 100  ? '#666' : 'white',
                                                    cursor: isSubmitDisabled || prolongationDays === "0" || prolongationDays > 100  ? 'not-allowed' : 'pointer',
                                                    marginTop: "25px"
                                                }}
                                                className="doc-submit-button"
                                                disabled={isSubmitDisabled || loading || prolongationDays === "0" || prolongationDays > 100}
                                            >
                                                დოკუმენტის შექმნა
                                            </button>
                                        </span>
                                    </Tooltip>
                                </form>
                            </div>
                            <div className="pdf-preview-container" style={{fontFamily: fontFamily}}>
                                {PdfPreviewContent}
                                <div>
                                    <div className="upload-single-container-decline">
                                        <div className="upload-single-header">
                                            <p className="upload-single-title">დანართის ატვირთვა</p>
                                        </div>
                                        <div className="upload-single-body">
                                            <Button variant="contained" onClick={() => fileInputRef.current.click()}
                                                    className="upload-single-button">
                                                აირჩიეთ ფაილი
                                            </Button>
                                            <input
                                                type="file"
                                                accept=".pdf"
                                                ref={fileInputRef}
                                                style={{display: 'none'}}
                                                onChange={handleFileChange}
                                            />
                                            {file && (
                                                <div className="upload-single-selected-file">
                                                    {file.name}
                                                    <IoTrash className="icon-button" onClick={handleFileDelete}/>
                                                    <IoEye className="icon-button" onClick={() => handlePreview(file)}/>
                                                </div>
                                            )}
                                            {file && <TextField
                                                label="ფაილის სახელი"
                                                variant="outlined"
                                                type="text"

                                                value={fileTitle}
                                                onChange={(e) => setFileTitle(e.target.value)}
                                            />}


                                        </div>
                                    </div>
                                </div>
                            </div>

                        </div>
                    )}
                    <IoIosCloseCircle className="upload-single-close-icon-text-editor"
                                      onClick={() => setCloseModalOn(true)}
                    />

                </div>

            )}
            {loading && <div className="loader"></div>}
            <ConfirmationModal
                isOpen={isConfirmModalOpen}
                onRequestClose={() => setIsConfirmModalOpen(false)}
                onConfirm={handleConfirmSubmit}
            />
            <ConfirmationModal
                isOpen={closeModalOn}
                onRequestClose={() => setCloseModalOn(false)}
                onConfirm={handleClosePopup}
                modalText={"დახურვის შემთხვევაში წაიშლება პროგრესიც!"}
            />
        </div>
    );
};

export default DenyCaseDocument;
